import { DEFAULT_REQUEST_ERROR } from '../../constants/MessageConstants'

export default ({ message = DEFAULT_REQUEST_ERROR, title }) => (
  <div className="alert alert-danger cb-alert-heading" role="alert" tabIndex="0">
    <h2>{title || 'Error'}</h2>
    <p>{message}</p>
  </div>
)
